import { useUiStateContext } from '~/hooks/useUiStateContext';

export function useUiStateContextPatchUiState() {
  const context = useUiStateContext();

  return context.patchUiState;
}
